import { createContext } from 'react';
import type { DialogState } from './types';

export type PaybackClient = {
  createModule: (
    options: {
      moduleType?: string;
      selector?: string;
      width?: number;
      height?: number;
      contextKey?: string;
    },
    overlayOptions?: { backdropDisabled?: boolean; height?: number; maximumWidth?: number },
  ) => void;

  createModuleInOverlay: (
    moduleOptions: {
      moduleType: 'entitlement';
      contextKey: 'overlayContext';
      options: { entitlementGroup: 'OIMIKI_MARKETING' };
      onSuccess: (client: unknown) => void;
    },
    overlayConfig: { backdropDisabled: boolean; height: number; maximumWidth: number },
  ) => void;
};

export interface PaybackClientContextValue {
  client?: PaybackClient | null;
  dialogState: DialogState;
  setDialogState: (state: DialogState) => void;
  closeDialogHandler: () => void;
}

export const PaybackClientContext = createContext<PaybackClientContextValue | undefined>(undefined);
